import { PlanState } from 'types';
import type { Plan } from 'types';

/**
 * A plan is "active" once it has been activated: it is no longer deactivated and
 * has reached the READY state. While active, its draft configuration is locked
 * and can no longer be edited in the Survey Results Season flow.
 */
export function isPlanActive(plan?: Plan | null): boolean {
  return !!plan && !plan.deactivated && plan.state === PlanState.READY;
}

/**
 * A plan is a "draft" while its composition can still be edited. Mirrors
 * assertPlanIsDraft on the API, which rejects survey edits with a 409 once the
 * plan leaves DRAFT — activation migrates the config row by row, so an edit
 * mid-activation would race it. An absent plan counts as a draft: nothing has
 * been committed yet.
 */
export function isPlanDraft(plan?: Plan | null): boolean {
  return !plan || plan.state === PlanState.DRAFT;
}

/**
 * A plan is "activating" while its activation job runs asynchronously: it has
 * left DRAFT for the CREATING state but is not yet READY. The activate step shows
 * an in-progress placeholder and locks navigation during this window.
 */
export function isPlanActivating(plan?: Plan | null): boolean {
  return !!plan && plan.state === PlanState.CREATING;
}
